import * as React from 'react';
import {styled} from '../../utils';
import {Link} from 'react-router-dom';
import {RouteComponentProps} from 'react-router';
import Breadcrumb, {BreadcrumbItem} from '../../components/Breadcrumb';
import Card, {CardBody, CardHeader as _CardHeader} from '../../components/Card';
import {Tab as _Tab, TabList} from '../../components/Tabs';
import Flex from '../../components/Flex';
import Airbnb from './private/Airbnb';
import Booking from './private/Booking';
import Vrbo from './private/Vrbo';

const Heading = styled('h2')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 26,
  fontWeight: 300,
  color: '#7C4EF6',
  marginBottom: 42
}));

const CardHeader = _CardHeader.withComponent(Flex);
const Tab = _Tab.withComponent(Link);

interface WithInjectedProps extends RouteComponentProps<{listingsProvider: string}> {}

export default class IntegrationInstructions extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Breadcrumb>
          <BreadcrumbItem href="/">Welcome</BreadcrumbItem>
          <BreadcrumbItem>Connect your listings</BreadcrumbItem>
        </Breadcrumb>
        <Card style={{marginTop: 20}}>
          <CardHeader>
            Connect your listings
            <TabList>
              <Tab to="/onboarding/airbnb.com">Airbnb.com</Tab>
              <Tab to="/onboarding/booking.com">Booking.com</Tab>
              <Tab to="/onboarding/vrbo.com">VRBO.com</Tab>
            </TabList>
          </CardHeader>
          <CardBody>
            <div style={{textAlign: 'center'}}>
              <Heading>Follow below steps to add your listings:</Heading>
              {this._renderInstructions()}
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _renderInstructions() {
    switch (this._withInjectedProps.match.params.listingsProvider) {
      case 'booking.com':
        return <Booking />;
      case 'vrbo.com':
        return <Vrbo />;
      default:
        return <Airbnb />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/IntegrationInstructions/IntegrationInstructions.tsx